import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { formatLocalizedTimeAgo } from "../../../../utils/formatDate";
import { formatNumberWithK } from "../../../../utils/formatters/numberFormatter";

import { ExpiryIcon } from "../../assets/icons/go-hire-icons";
import { ServiceRequestTypeEnum, ServiceRequestUnitEnum } from "../../enum/service.enum";

import { styles } from "./styles";

interface ServiceHeaderProps {
  amount: number;
  currency: string;
  type: string;
  expiryDate?: string;
  paymentType?: ServiceRequestTypeEnum;
  unit?: ServiceRequestUnitEnum;
}

export const ServiceHeader = ({ amount, currency, type, expiryDate, paymentType, unit }: ServiceHeaderProps) => {
  const { t, i18n } = useTranslation("goService", { keyPrefix: "servicePage" });
  const { t: tCurrency } = useTranslation("goService", { keyPrefix: "serviceCurrency" });
  const { t: tServiceType } = useTranslation("goService", { keyPrefix: "serviceType" });

  return (
    <Box sx={styles.headerContent}>
      <Box sx={styles.priceContainer}>
        <Typography sx={styles.price}>{`${tCurrency(currency)}${amount / 100}`}</Typography>
        {/* <Typography sx={styles.type}>/{tServiceType(type)}</Typography> */}
        <Typography sx={styles.type}>
          {paymentType === ServiceRequestTypeEnum.Unit && unit
            ? t(unit, { amount: `${tCurrency(currency)}${formatNumberWithK(amount / 100, i18n.language)}` })
            : ""}
        </Typography>
      </Box>
      {expiryDate && (
        <Typography sx={styles.expiresIn}>
          <ExpiryIcon /> {`${t("expiresIn")} ${formatLocalizedTimeAgo(expiryDate, i18n.language)}`}
        </Typography>
      )}
    </Box>
  );
};
